export default "__VITE_ASSET__BFCmsVli__"